// Sprechblasen über Figuren und Objekten (CSS2D, damit Text scharf bleibt).
// Automatische Sprechblasen erscheinen nur in der Nahansicht; angeklickte (force) immer.
import { CSS2DObject } from "three/addons/renderers/CSS2DRenderer.js"

let gate = () => true
const active = new Set()

export function setBubbleGate(fn) {
  gate = fn
}

export function bubblesAllowed() {
  return gate()
}

// Einmal pro Frame: automatische Sprechblasen ausblenden, sobald man herauszoomt.
export function updateBubbles() {
  const allowed = gate()
  for (const bubble of active) bubble.visible = allowed || bubble.userData.forced
}

// Alle Sprechblasen sofort entfernen (z. B. beim Wechsel des Werks).
export function clearBubbles() {
  for (const bubble of active) {
    bubble.removeFromParent()
    bubble.element.remove()
  }
  active.clear()
}

export function say(object, html, { duration = 2000, tone = "light", y = 1.55, force = false } = {}) {
  if (!force && !gate()) return null
  object.userData.bubble?.removeFromParent()
  const element = document.createElement("div")
  const colors = tone === "bump" ? "bg-lime text-navy" : "bg-white text-navy"
  element.className = `pointer-events-none max-w-[260px] -translate-y-full rounded-2xl px-3 py-1.5 text-center text-[15px] leading-snug font-bold shadow-lg transition-opacity duration-300 ${colors}`
  element.innerHTML = html
  const bubble = new CSS2DObject(element)
  bubble.userData.forced = force
  bubble.position.set(0, y, 0)
  object.add(bubble)
  object.userData.bubble = bubble
  active.add(bubble)
  setTimeout(() => (element.style.opacity = "0"), duration - 300)
  setTimeout(() => {
    if (object.userData.bubble === bubble) object.userData.bubble = null
    bubble.removeFromParent()
    bubble.element.remove()
    active.delete(bubble)
  }, duration)
  return bubble
}

// Sprechblase mit Name und Rolle über dem Spruch – nur nach Klick, daher immer sichtbar.
// Es ist immer nur eine solche Vorstellung offen: ein neuer Klick schließt die vorige.
let lastIntroduction = null

export function introduce(object, { name, role }, quote, options = {}) {
  if (lastIntroduction && lastIntroduction.parent) {
    const previousOwner = lastIntroduction.parent
    lastIntroduction.removeFromParent()
    lastIntroduction.element.remove()
    active.delete(lastIntroduction)
    if (previousOwner.userData.bubble === lastIntroduction) previousOwner.userData.bubble = null
  }
  lastIntroduction = say(object, `<span class="block text-[12px] font-semibold text-muted">${name} · ${role}</span>${quote}`, { duration: 3200, force: true, ...options })
  return lastIntroduction
}
